import React from "react";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { ButtonColour, ButtonSize } from "@trussle/external-components";
import { IContentfulBackgroundColour } from "../../../../types/IContentfulBackgroundColour";
import { IContentfulRichTextResponse } from "../../../../types/IContentfulRichText";
import { PanelWrapper } from "../../../PanelWrapper";
import { InternalCTALink } from "../../../CallToActions/internalCTALink";
import { ICTA } from "../../../../types/ICTA";
import { trackEvent } from "../../../../helpers/analytics";
import { usePageTitle } from "../../../PageTitle";
import BgImage3D from "./BgImage3D";

import "./styles.scss";

export interface IImportantInfoProps {
  title?: string;
  mainContent?: IContentfulRichTextResponse;
  ctas?: ICTA[];
  backgroundColour?: IContentfulBackgroundColour;
}

export const ImportantInfoPanel: React.FC<IImportantInfoProps> = ({
  title,
  mainContent,
  ctas,
  backgroundColour,
}) => {
  const page = usePageTitle();
  const hasCTAs = ctas && ctas.length > 0;

  const handleClick = async (value: string) => {
    await trackEvent("Call to Action Clicked", {
      module: "SplashPanel",
      value,
      page,
    });
  };

  return (
    <PanelWrapper backgroundColour={backgroundColour} className="important-info-panel" isBetterV2>
      <div className="important-info-panel__wrapper">
        {hasCTAs && (
          <div className={`important-info-panel__background-image-left ${backgroundColour}`}>
            <BgImage3D variant={backgroundColour} side="left" />
          </div>
        )}
        {hasCTAs && (
          <div className="important-info-panel__cta-wrapper">
            {ctas.map((cta) => (
              <div className="important-info-panel__cta-item" key={cta.title}>
                <h4>{cta.subtitle}</h4>
                <p>{cta.description}</p>
                <InternalCTALink
                  ctaColour={ButtonColour.Black}
                  size={ButtonSize.Large}
                  title={cta.title}
                  url={cta.url}
                  isInternal
                  buttonClasses="important-info-panel__cta-item__button"
                  handleClick={() => handleClick(cta.title)}
                />
              </div>
            ))}
          </div>
        )}
        <p className="important-info-panel-title">{title}</p>
        <div className="important-info-panel-text">
          {mainContent && renderRichText(mainContent)}
        </div>
        {hasCTAs && (
          <div className={`important-info-panel__background-image-right ${backgroundColour}`}>
            <BgImage3D variant={backgroundColour} side="right" />
          </div>
        )}
      </div>
    </PanelWrapper>
  );
};
